import React from 'react';
import classNames from 'classnames';

export interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const InfoMessage: React.FC<Props> = ({ className, ...rest }) => (
  <div className={classNames('py-3 px-4 bg-scarlet-50 rounded', className)} {...rest} />
);
